import React, { useState } from "react";
import { useSelector } from "react-redux";
import Drawer from "@mui/material/Drawer";
import { MyProfile } from "./myProfile";
import { TextToolTip } from "components";
import { Svg } from "assets";
import {ProfileInfo} from "utils";

export const UserInfo = ({ openingMenu }) => {
  const [drawerPosition, setDrawerPosition] = useState({ left: false });
  const user = useSelector((state) => state.auth.myProfile);
    const {myProfile} = ProfileInfo();

  const toggleDrawer = (anchor, open) => {
    setDrawerPosition({ ...drawerPosition, [anchor]: open });
  };

  return (
    <div className="user-info-wrapper">
      {(myProfile?.avatar?.url || myProfile?.firstName || myProfile?.lastName) && (
        <div
          onClick={() => toggleDrawer("left", !drawerPosition.left)}
          className="user-info-box"
          style={{
            background: drawerPosition.left ? "rgba(255, 255, 255, 0.08)" : "",
          }}
        >
          <div className="user-avatar-wrapper">
            {myProfile?.avatar?.url ? (
              <img src={user?.avatar?.url} alt="Avatar" />
            ) : myProfile?.firstName || myProfile?.lastName ? (
              <p className="user-avatar-FLName">
                {`${
                  myProfile?.firstName
                    ? myProfile?.firstName?.[0]?.toUpperCase()
                    : ""
                } ${myProfile?.lastName ? myProfile?.lastName?.[0]?.toUpperCase() : ""}`}
              </p>
            ) : (
              ""
            )}
          </div>

          {(myProfile?.firstName || myProfile?.lastName) && openingMenu && (
            <div className="user-info-name-arrow">
              <TextToolTip
                classNameText="user-info-name"
                text={`${myProfile?.firstName || ""} ${myProfile?.lastName || ""}`}
                content={`${myProfile?.firstName || ""} ${myProfile?.lastName || ""}`}
              />
              {drawerPosition.left && <Svg.ArrowRightSvg />}
            </div>
          )}
        </div>
      )}

      <Drawer
        className={`my-profile-drawer ${openingMenu ? "my-profile-drawer-open" : ""}`}
        anchor={"left"}
        open={drawerPosition.left}
        onClose={() => toggleDrawer("left", false)}
      >
        <MyProfile info={myProfile} />
      </Drawer>
    </div>
  );
};
